import { useQuery } from '@tanstack/react-query';

import { ResolvedPortalConfig, resolvePortalConfig } from '../registry/resolvePortalConfig';
import { getPortalConfig } from '../services/reportService';

export const usePortalConfig = (): ResolvedPortalConfig => {
  const { data } = useQuery({
    queryKey: ['portal-config'],
    queryFn: getPortalConfig,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  return resolvePortalConfig(data);
};
